import { apis } from "../config";
import { Post } from "@/utils/request";
// 手动出入场
export function carPass(data){
    return Post(apis.park.carPass,data)
}
// 免费开闸
export function openGate(data){
    return Post(apis.park.openGate,data)
}
// 确认收费
export function confirmOrderMoney(data){
   return Post(apis.park.confirmOrderMoney,data)
}
// 查询客户端版本
export function queryCliVersion(data){
    return Post(apis.park.queryCliVersion,data)
}
// 手动关闸
export function closeGate(data){
    return Post(apis.park.closeGate,data)
}
// 手动关闸
export function videoList(data){
    return Post(apis.park.videoList,data)
}
// 出场类型
export function outPassType(data){
    return Post(apis.park.outPassType,data)
}
// 扫码支付
export function scanPay(data){
    return Post(apis.park.scanPay,data)
}
// 锁闸
export function lockGate(data){
    return Post(apis.park.lockGate,data)
}
// 锁闸解锁
export function unLockGate(data){
    return Post(apis.park.unLockGate,data)
}
// 清除在场车辆
export function clearParkingCar(data){
    return Post(apis.park.clearParkingCar,data)
}
// 余位设置
export function setSpotCanUseNum(data){
    return Post(apis.park.setSpotCanUseNum,data)
}
export function queryParkLotDetailById(data){
    return Post(apis.park.queryParkLotDetailById,data)
}
//相机监控
export function queryParkLotGateCam(data){
    return Post(apis.park.queryParkLotGateCam,data)
}
//盒子监控
export function queryParkLotBoxInfo(data){
    return Post(apis.park.queryParkLotBoxInfo,data)
}
//Domain
export function getCurrentTenant(data){
    return Post(apis.park.getCurrentTenant,data)
}
//出入口视频排序
export function sortParkLotGate(data){
    return Post(apis.park.sortParkLotGate,data)
}
//岗亭统计金额字段排序
export function sortSentryStatField(data){
    return Post(apis.park.sortSentryStatField,data)
}
//二次确认进场
export function openSurePassIn(data){
    return Post(apis.park.openSurePassIn,data)
}
//二次确认进场 禁止入场
export function openForbidPassIn(data){
    return Post(apis.park.openForbidPassIn,data)
}
//厂商
export function queryCamFactory(data){
    return Post(apis.park.queryCamFactory,data)
}
